import classNames from 'classnames'
import React from 'react'
import styles from './Cards.module.scss'

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  cardClassName?: string
}

export const Card = ({
  cardClassName,
  children,
  className,
  ...rest
}: CardProps) => (
  <div className={classNames(styles.card, cardClassName, className)} {...rest}>
    {children}
  </div>
)
